module.exports = __webpack_public_path__ + "static/media/Mouse sensitivity measured.e83f233f.svg";